import { render, staticRenderFns } from "./DuelPlayers.vue?vue&type=template&id=17c066d4&lang=pug"
import script from "./DuelPlayers.vue?vue&type=script&lang=js"
export * from "./DuelPlayers.vue?vue&type=script&lang=js"
import style0 from "./DuelPlayers.vue?vue&type=style&index=0&id=17c066d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports